import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { filmProfile } from "@/mocks/film";

export default function FilmProfile() {
  return (
    <section id="profile" className="scroll-mt-32 bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="01 / 影片档案"
            title="先对齐基本信息，再谈剧情"
            desc="不同来源对这部片的译名、片长与演职员信息偶有出入，这里把常用字段集中列出，方便你在阅读剧情和角色之前先核对一遍。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <Reveal className="lg:col-span-7" delay={60}>
            <div className="h-full rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
              <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                {filmProfile.facts.map((fact) => (
                  <div key={fact.label} className="flex items-baseline justify-between gap-4 border-b border-background-200/70 pb-3">
                    <dt className="shrink-0 text-sm text-foreground-500 font-label">{fact.label}</dt>
                    <dd className="text-sm md:text-[15px] font-medium text-foreground-950 text-right">
                      {fact.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="h-full rounded-lg bg-accent-500 text-background-50 p-5 md:p-6 flex flex-col">
              <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-xs font-label">
                <i className="ri-double-quotes-l" aria-hidden="true" />
                一句话概括
              </span>
              <p className="font-heading mt-4 text-lg md:text-xl leading-relaxed font-semibold">
                {filmProfile.tagline}
              </p>
              <div className="mt-auto pt-6 space-y-3 text-sm text-background-100/90">
                <div className="flex gap-2">
                  <i className="ri-emotion-line mt-0.5" aria-hidden="true" />
                  <span>情绪基调：安静、压抑中带暖，克制收尾。</span>
                </div>
                <div className="flex gap-2">
                  <i className="ri-lightbulb-line mt-0.5" aria-hidden="true" />
                  <span>观看建议：适合安静环境，很多信息藏在台词间隙。</span>
                </div>
                <div className="flex gap-2">
                  <i className="ri-error-warning-line mt-0.5" aria-hidden="true" />
                  <span>内容提示：偏剧情向，节奏慢，无强刺激场面。</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}